import api from "@/config/api";
const path = "public/token"

export default {
  getInfo: (token) => {
    return api.get(`${path}/${token}`)
  }
}
